export default __webpack_public_path__ + "static/media/light_moon.a5ba61e3.svg";